// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as DevelopersRouteImport } from './routes/developers'
import { Route as DashboardRouteImport } from './routes/_dashboard'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ShareTokenRouteImport } from './routes/share.$token'
import { Route as DashboardIntegrationsRouteImport } from './routes/_dashboard.integrations'
import { Route as DashboardBillingRouteImport } from './routes/_dashboard.billing'
import { Route as DashboardAutomationsRouteImport } from './routes/_dashboard.automations'
import { Route as DashboardAccountRouteImport } from './routes/_dashboard.account'
import { Route as IntegrationsGoogleSearchConsoleCallbackRouteImport } from './routes/integrations/google-search-console/callback'
import { Route as IntegrationsGoogleAdsCallbackRouteImport } from './routes/integrations/google-ads/callback'
import { Route as AuthGoogleCallbackRouteImport } from './routes/auth/google/callback'
import { Route as DashboardTeammatesIdRouteImport } from './routes/_dashboard.teammates.$id'
import { Route as DashboardRunsRunIdRouteImport } from './routes/_dashboard.runs.$runId'

const VerifyEmailRoute = VerifyEmailRouteImport.update({
            id: '/verify-email',path: '/verify-email',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const SignupRoute = SignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const DevelopersRoute = DevelopersRouteImport.update({
            id: '/developers',path: '/developers',getParentRoute: () => rootRouteImport
          })
const DashboardRoute = DashboardRouteImport.update({
            id: '/_dashboard',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ShareTokenRoute = ShareTokenRouteImport.update({
            id: '/share/$token',path: '/share/$token',getParentRoute: () => rootRouteImport
          })
const DashboardIntegrationsRoute = DashboardIntegrationsRouteImport.update({
            id: '/integrations',path: '/integrations',getParentRoute: () => DashboardRoute
          })
const DashboardBillingRoute = DashboardBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => DashboardRoute
          })
const DashboardAutomationsRoute = DashboardAutomationsRouteImport.update({
            id: '/automations',path: '/automations',getParentRoute: () => DashboardRoute
          })
const DashboardAccountRoute = DashboardAccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => DashboardRoute
          })
const IntegrationsGoogleSearchConsoleCallbackRoute = IntegrationsGoogleSearchConsoleCallbackRouteImport.update({
            id: '/integrations/google-search-console/callback',path: '/integrations/google-search-console/callback',getParentRoute: () => rootRouteImport
          })
const IntegrationsGoogleAdsCallbackRoute = IntegrationsGoogleAdsCallbackRouteImport.update({
            id: '/integrations/google-ads/callback',path: '/integrations/google-ads/callback',getParentRoute: () => rootRouteImport
          })
const AuthGoogleCallbackRoute = AuthGoogleCallbackRouteImport.update({
            id: '/auth/google/callback',path: '/auth/google/callback',getParentRoute: () => rootRouteImport
          })
const DashboardTeammatesIdRoute = DashboardTeammatesIdRouteImport.update({
            id: '/teammates/$id',path: '/teammates/$id',getParentRoute: () => DashboardRoute
          })
const DashboardRunsRunIdRoute = DashboardRunsRunIdRouteImport.update({
            id: '/runs/$runId',path: '/runs/$runId',getParentRoute: () => DashboardRoute
          })





const DashboardRouteChildren = {
  DashboardAccountRoute: DashboardAccountRoute,DashboardAutomationsRoute: DashboardAutomationsRoute,DashboardBillingRoute: DashboardBillingRoute,DashboardIntegrationsRoute: DashboardIntegrationsRoute,DashboardRunsRunIdRoute: DashboardRunsRunIdRoute,DashboardTeammatesIdRoute: DashboardTeammatesIdRoute
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(DashboardRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,DashboardRoute: DashboardRouteWithChildren,DevelopersRoute: DevelopersRoute,ForgotPasswordRoute: ForgotPasswordRoute,LoginRoute: LoginRoute,PricingRoute: PricingRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,ResetPasswordRoute: ResetPasswordRoute,SignupRoute: SignupRoute,TermsRoute: TermsRoute,VerifyEmailRoute: VerifyEmailRoute,ShareTokenRoute: ShareTokenRoute,AuthGoogleCallbackRoute: AuthGoogleCallbackRoute,IntegrationsGoogleAdsCallbackRoute: IntegrationsGoogleAdsCallbackRoute,IntegrationsGoogleSearchConsoleCallbackRoute: IntegrationsGoogleSearchConsoleCallbackRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)